module.exports = __webpack_public_path__ + "img/xwh.7afa2bef.png";